import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface RenameViewModalData {
    currentName: string;
}

@Component({
  selector: 'rename-view-modal',
  templateUrl: 'rename-view-modal.component.html',
  styleUrls: ['./rename-view-modal.component.scss']
})
export class RenameViewModalComponent {
    public newName: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: RenameViewModalData,
        private dialogRef: MatDialogRef<RenameViewModalComponent>
    ) {
        this.newName = data.currentName;
    }

    public save() {
        if (this.newName && this.newName.trim()) {
            this.dialogRef.close(this.newName.trim());
        }
    }

    public cancel() {
        this.dialogRef.close();
    }
}
